// We do not need these on Web/Desktop as their implementation defer from Native devices so just noop them
const codeWordWrapper = {};
const codeWordStyle = {};
const codeTextStyle = {};
export default {codeWordWrapper, codeWordStyle, codeTextStyle};
